const buildingModelCommentConstants = {
	GET_BUILDING_MODEL_COMMENTS: "GET_BUILDING_MODEL_COMMENTS",
	CREATE_BUILDING_MODEL_COMMENT: "CREATE_BUILDING_MODEL_COMMENT",
	REPLY_BUILDING_MODEL_COMMENT: "REPLY_BUILDING_MODEL_COMMENT",
	BUILDING_MODEL_COMMENT_REQUEST: "BUILDING_MODEL_COMMENT_REQUEST",
	BUILDING_MODEL_COMMENT_SUCCESS: "BUILDING_MODEL_COMMENT_SUCCESS",
	BUILDING_MODEL_COMMENT_FAILURE: "BUILDING_MODEL_COMMENT_FAILURE",
	BUILDING_MODEL_COMMENT_CREATE_SUCCESS:
		"BUILDING_MODEL_COMMENT_CREATE_SUCCESS",
	BUILDING_MODEL_COMMENT_REPLY_SUCCESS: "BUILDING_MODEL_COMMENT_REPLY_SUCCESS",
	BUILDING_MODEL_COMMENT_SET_SUCCESS_MESSAGE:
		"BUILDING_MODEL_COMMENT_SET_SUCCESS_MESSAGE",
	CLEAR_BUILDING_MODEL_COMMENTS: "CLEAR_BUILDING_MODEL_COMMENTS",
};

export default buildingModelCommentConstants;
